// Tracks recently viewed listings (for offline browsing) and how many
// distinct listings a visitor has opened (for the install-prompt nudge).
const RECENT_KEY = "rento_recent_listings";
const VIEWED_IDS_KEY = "rento_viewed_ids";
const MAX_RECENT = 8;

export function recordListingView(listing) {
  if (!listing || !listing.id) return;
  try {
    const ids = JSON.parse(localStorage.getItem(VIEWED_IDS_KEY) || "[]");
    if (!ids.includes(listing.id)) {
      ids.push(listing.id);
      localStorage.setItem(VIEWED_IDS_KEY, JSON.stringify(ids));
    }
    const recent = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]").filter((l) => l.id !== listing.id);
    recent.unshift({
      id: listing.id, title: listing.title, price: listing.price, currency: listing.currency,
      listing_type: listing.listing_type, property_type: listing.property_type,
      county: listing.county, town: listing.town, photos: (listing.photos || []).slice(0, 1),
    });
    localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, MAX_RECENT)));
  } catch {
    /* noop */
  }
}

export function getRecentListings() {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
  } catch {
    return [];
  }
}

export function getRecentListing(id) {
  return getRecentListings().find((l) => l.id === id) || null;
}

export function viewedCount() {
  try {
    return JSON.parse(localStorage.getItem(VIEWED_IDS_KEY) || "[]").length;
  } catch {
    return 0;
  }
}
